import getLocal from '@/app/utils/i18n';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';
import EfImg from '@elem/ui/ef-img';
import EcoSpace from 'eco-design/base/eco-space';
import { useRef, useState } from 'react';
import { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { IPageStatus } from '../../config/IPageStatus';
import { useProductPageStatus } from '../../ProductProvider';
import styles from './index.module.scss';
import useSwiperAnimate from './useSwiperAnimate';

const Arrow = ({ style }: any) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="53" height="52" style={style} viewBox="0 0 53 52" fill="none">
        <g clipPath="url(#clip0_422_15080)">
            <circle opacity="0.2" cx="25.7143" cy="25.7143" r="25.7143" transform="matrix(-1 0 0 1 52.0723 0.579346)" fill="black" />
            <path d="M28.5008 32.7216L22.0723 26.2931L28.5008 19.8645" stroke="white" strokeWidth="2.14286" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_422_15080">
                <rect width="51.4286" height="51.4286" fill="white" transform="matrix(-1 0 0 1 52.0723 0.579346)" />
            </clipPath>
        </defs>
    </svg>
);

function DeviceSwiper() {
    const { t } = useLang('rapidseries.swiper');
    const { locale } = getLocal();
    const IS_NA = ['us', 'ca'].includes(locale);
    const [activeIndex, setActiveIndex] = useState(0);
    const tabContainerRef = useRef<HTMLDivElement>(null);
    const targetRef = useRef<HTMLDivElement>(null);
    const pageStatus = useProductPageStatus();

    const Tab_List = IS_NA
        ? [
              {
                  tabLabel: t('tab1'),
                  tabValue: '0',
                  imgs: [
                      {
                          pc: 'https://websiteoss.ecoflow.com/upload/image/1749435586293/pc_Remote%20work_01.jpg',
                          h5: 'https://websiteoss.ecoflow.com/upload/image/1749436179852/m_Remote%20work_01.jpg',
                      },
                      {
                          pc: 'https://websiteoss.ecoflow.com/upload/image/1749435586929/pc_Remote%20work_02.jpg',
                          h5: 'https://websiteoss.ecoflow.com/upload/image/1749436179353/m_Remote%20work_02.jpg',
                      },
                      {
                          pc: 'https://websiteoss.ecoflow.com/upload/image/1754621846635/Travel_03.jpg',
                          h5: 'https://websiteoss.ecoflow.com/upload/image/1754621846448/Travel_03%20(1).jpg',
                      },
                  ],
              },
              {
                  tabLabel: t('tab2'),
                  tabValue: '1',
                  imgs: [
                      {
                          pc: 'https://websiteoss.ecoflow.com/upload/image/1754621219572/Travel_01.jpg',
                          h5: 'https://websiteoss.ecoflow.com/upload/image/1754621219382/Travel_01%20(1).jpg',
                      },
                      {
                          pc: 'https://websiteoss.ecoflow.com/upload/image/1749435588071/pc_Travel_02.jpg',
                          h5: 'https://websiteoss.ecoflow.com/upload/image/1749436097323/m_Travel_02.jpg',
                      },
                      {
                          pc: 'https://websiteoss.ecoflow.com/figma-uploads/1762996995083-exia9g-compressed-travel%EF%BC%881920/1366%EF%BC%89.jpg',
                          h5: 'https://websiteoss.ecoflow.com/figma-uploads/1762997012287-zjoepm-compressed-768/375.jpg',
                      },
                  ],
              },
              {
                  tabLabel: t('tab3'),
                  tabValue: '2',
                  imgs: [
                      {
                          pc: 'https://websiteoss.ecoflow.com/upload/image/1754621220012/Desktop_01.jpg',
                          h5: 'https://websiteoss.ecoflow.com/upload/image/1754621219224/Desktop_01%20(1).jpg',
                      },
                      {
                          pc: 'https://websiteoss.ecoflow.com/upload/image/1754621219856/Desktop_02.jpg',
                          h5: 'https://websiteoss.ecoflow.com/upload/image/1754621220209/Desktop_02%20(1).jpg',
                      },
                      {
                          pc: 'https://websiteoss.ecoflow.com/upload/image/1749435586054/pc_In%20the%20Office_03.jpg',
                          h5: 'https://websiteoss.ecoflow.com/upload/image/1749436180153/m_In%20the%20Office_03.jpg',
                      },
                  ],
              },
              {
                  tabLabel: t('tab4'),
                  tabValue: '3',
                  imgs: [
                      {
                          pc: 'https://websiteoss.ecoflow.com/figma-uploads/1762478051226-3hff1o-compressed-at%20home%EF%BC%881920/1366%EF%BC%89.jpg',
                          h5: 'https://websiteoss.ecoflow.com/figma-uploads/1762478061425-2ehmhg-compressed-768/375.jpg',
                      },
                      {
                          pc: 'https://websiteoss.ecoflow.com/upload/image/1749435863013/pc_Entertaiment_02.jpg',
                          h5: 'https://websiteoss.ecoflow.com/upload/image/1749436096202/m_Entertaiment_02.jpg',
                      },
                      {
                          pc: 'https://websiteoss.ecoflow.com/upload/image/1749435586482/pc_Entertaiment_03.jpg',
                          h5: 'https://websiteoss.ecoflow.com/upload/image/1749436097031/m_Entertaiment_03.jpg',
                      },
                  ],
              },
          ]
        : locale === 'jp'
        ? [
              {
                  tabLabel: t('tab1'),
                  tabValue: '0',
                  imgs: [
                      {
                          pc: 'https://websiteoss.ecoflow.com/upload/image/1749435586293/pc_Remote%20work_01.jpg',
                          h5: 'https://websiteoss.ecoflow.com/upload/image/1749436179852/m_Remote%20work_01.jpg',
                      },
                      {
                          pc: 'https://websiteoss.ecoflow.com/upload/image/1749435586929/pc_Remote%20work_02.jpg',
                          h5: 'https://websiteoss.ecoflow.com/upload/image/1749436179353/m_Remote%20work_02.jpg',
                      },
                      {
                          pc: 'https://websiteoss.ecoflow.com/upload/image/1749435587401/pc_Remote%20work_03.jpg',
                          h5: 'https://websiteoss.ecoflow.com/upload/image/1749436180425/m_Remote%20work_03.jpg',
                      },
                  ],
              },
              {
                  tabLabel: t('tab2'),
                  tabValue: '1',
                  imgs: [
                      {
                          pc: 'https://websiteoss.ecoflow.com/upload/image/1762853399248/2.jpg',
                          h5: 'https://websiteoss.ecoflow.com/upload/image/1762853286524/2-m.jpg',
                      },
                      {
                          pc: 'https://websiteoss.ecoflow.com/upload/image/1749435588071/pc_Travel_02.jpg',
                          h5: 'https://websiteoss.ecoflow.com/upload/image/1749436097323/m_Travel_02.jpg',
                      },
                      {
                          pc: 'https://websiteoss.ecoflow.com/upload/image/1749435587878/pc_Travel_03.jpg',
                          h5: 'https://websiteoss.ecoflow.com/upload/image/1749436097611/m_Travel_03.jpg',
                      },
                  ],
              },
              {
                  tabLabel: t('tab3'),
                  tabValue: '2',
                  imgs: [
                      {
                          pc: 'https://websiteoss.ecoflow.com/upload/image/1762853286236/3.jpg',
                          h5: 'https://websiteoss.ecoflow.com/upload/image/1762853286731/3-m.jpg',
                      },
                      {
                          pc: 'https://websiteoss.ecoflow.com/upload/image/1749435587151/pc_In%20the%20Office_02.jpg',
                          h5: 'https://websiteoss.ecoflow.com/upload/image/1749436179569/m_In%20the%20Office_02.jpg',
                      },
                      {
                          pc: 'https://websiteoss.ecoflow.com/upload/image/1749435586054/pc_In%20the%20Office_03.jpg',
                          h5: 'https://websiteoss.ecoflow.com/upload/image/1749436180153/m_In%20the%20Office_03.jpg',
                      },
                  ],
              },
              {
                  tabLabel: t('tab4'),
                  tabValue: '3',
                  imgs: [
                      {
                          pc: 'https://websiteoss.ecoflow.com/upload/image/1762853286162/4.jpg',
                          h5: 'https://websiteoss.ecoflow.com/upload/image/1762853286352/4-m.jpg',
                      },
                      {
                          pc: 'https://websiteoss.ecoflow.com/upload/image/1749435863013/pc_Entertaiment_02.jpg',
                          h5: 'https://websiteoss.ecoflow.com/upload/image/1749436096202/m_Entertaiment_02.jpg',
                      },
                      {
                          pc: 'https://websiteoss.ecoflow.com/upload/image/1749435586482/pc_Entertaiment_03.jpg',
                          h5: 'https://websiteoss.ecoflow.com/upload/image/1749436097031/m_Entertaiment_03.jpg',
                      },
                  ],
              },
          ]
        : [
              {
                  tabLabel: t('tab1'),
                  tabValue: '0',
                  imgs: [
                      {
                          pc: 'https://websiteoss.ecoflow.com/upload/image/1749435586293/pc_Remote%20work_01.jpg',
                          h5: 'https://websiteoss.ecoflow.com/upload/image/1749436179852/m_Remote%20work_01.jpg',
                      },
                      {
                          pc: 'https://websiteoss.ecoflow.com/upload/image/1749435586929/pc_Remote%20work_02.jpg',
                          h5: 'https://websiteoss.ecoflow.com/upload/image/1749436179353/m_Remote%20work_02.jpg',
                      },
                      {
                          pc: 'https://websiteoss.ecoflow.com/upload/image/1749435587401/pc_Remote%20work_03.jpg',
                          h5: 'https://websiteoss.ecoflow.com/upload/image/1749436180425/m_Remote%20work_03.jpg',
                      },
                  ],
              },
              {
                  tabLabel: t('tab2'),
                  tabValue: '1',
                  imgs: [
                      {
                          pc: 'https://websiteoss.ecoflow.com/upload/image/1749435586713/pc_Travel_01.jpg',
                          h5: 'https://websiteoss.ecoflow.com/upload/image/1749436096415/m_Travel_01.jpg',
                      },
                      {
                          pc: 'https://websiteoss.ecoflow.com/upload/image/1749435588071/pc_Travel_02.jpg',
                          h5: 'https://websiteoss.ecoflow.com/upload/image/1749436097323/m_Travel_02.jpg',
                      },
                      {
                          pc: 'https://websiteoss.ecoflow.com/upload/image/1749435587878/pc_Travel_03.jpg',
                          h5: 'https://websiteoss.ecoflow.com/upload/image/1749436097611/m_Travel_03.jpg',
                      },
                  ],
              },
              {
                  tabLabel: t('tab3'),
                  tabValue: '2',
                  imgs: [
                      {
                          pc: 'https://websiteoss.ecoflow.com/upload/image/1749435862837/pc_In%20the%20Office_01.jpg',
                          h5: 'https://websiteoss.ecoflow.com/upload/image/1749436180646/m_In%20the%20Office_01.jpg',
                      },
                      {
                          pc: 'https://websiteoss.ecoflow.com/upload/image/1749435587151/pc_In%20the%20Office_02.jpg',
                          h5: 'https://websiteoss.ecoflow.com/upload/image/1749436179569/m_In%20the%20Office_02.jpg',
                      },
                      {
                          pc: 'https://websiteoss.ecoflow.com/upload/image/1749435586054/pc_In%20the%20Office_03.jpg',
                          h5: 'https://websiteoss.ecoflow.com/upload/image/1749436180153/m_In%20the%20Office_03.jpg',
                      },
                  ],
              },
              {
                  tabLabel: t('tab4'),
                  tabValue: '3',
                  imgs: [
                      {
                          pc: 'https://websiteoss.ecoflow.com/upload/image/1749435587653/pc_Entertaiment_01.jpg',
                          h5: 'https://websiteoss.ecoflow.com/upload/image/1749436096728/m_Entertaiment_01.jpg',
                      },
                      {
                          pc: 'https://websiteoss.ecoflow.com/upload/image/1749435863013/pc_Entertaiment_02.jpg',
                          h5: 'https://websiteoss.ecoflow.com/upload/image/1749436096202/m_Entertaiment_02.jpg',
                      },
                      {
                          pc: 'https://websiteoss.ecoflow.com/upload/image/1749435586482/pc_Entertaiment_03.jpg',
                          h5: 'https://websiteoss.ecoflow.com/upload/image/1749436097031/m_Entertaiment_03.jpg',
                      },
                  ],
              },
          ];
    const Img_List = Tab_List[activeIndex].imgs;

    const { slideChangeHandle, hanldleMouseEnter, hanldleMouseLeave, changeSwiper } = useSwiperAnimate({
        swiperClassName: 'device-swiper',
        list: Img_List,
    });

    const handleSlideChange = (swiper: any) => {
        slideChangeHandle(swiper);
    };

    const scrollTabToCenter = (tabElement: HTMLDivElement) => {
        if (!tabContainerRef.current) return;

        const container = tabContainerRef.current;
        const containerWidth = container.offsetWidth;
        const tabWidth = tabElement.offsetWidth;
        const tabLeft = tabElement.offsetLeft;
        const tabRight = tabLeft + tabWidth;

        // 计算需要滚动的距离，使标签居中
        const scrollPosition = tabLeft - (containerWidth - tabWidth) / 2;

        // 平滑滚动到计算位置
        container.scrollTo({
            left: scrollPosition,
            behavior: 'smooth',
        });
    };
    const handleTabClick = (index: number) => {
        setActiveIndex(index);
        // 延迟执行滚动，确保DOM已更新
        setTimeout(() => {
            if (index === activeIndex) return;
            const target = targetRef.current || ({} as HTMLDivElement);
            if (index === 0 || index === 1) {
                target.scrollTo({ left: 0, behavior: 'smooth' });
            } else {
                scrollTabToCenter(target);
            }
        }, 0);
        gtm.push({
            event: 'uaEvent',
            event_name: 'tab_click',
            list_name: t('title'),
            button_name: Tab_List[index].tabLabel,
            __btn_id1: `Rapid-Series-E .tab-${index + 1}`,
            __btn_id2: Tab_List[index].tabLabel,
            __btn_type: 'text',
        });
    };

    const handleNavigationClick = (direction: 'prev' | 'next') => {
        if (pageStatus === IPageStatus.statusA) {
            // 预热页：编号 109
            gtm.push({
                event: 'uaEvent',
                event_name: 'product_preview_page',
                list_name: t('title'),
                button_name: direction === 'prev' ? 'Left switch' : 'Right switch',
                __btn_id1: `Rapid-Series-E .device-swiper-navigation-${direction === 'prev' ? 'left' : 'right'}`,
                __btn_id2: direction === 'prev' ? '<' : '>',
                __btn_type: 'text',
            });
        }
        if (pageStatus === IPageStatus.statusB) {
            // 正式页：编号 48
            gtm.push({
                event: 'uaEvent',
                event_name: 'product_detail_page',
                list_name: t('title'),
                button_name: direction === 'prev' ? 'Left switch' : 'Right switch',
                __btn_id1: `Rapid-Series-E .device-swiper-navigation-${direction === 'prev' ? 'left' : 'right'}`,
                __btn_id2: direction === 'prev' ? '<' : '>',
                __btn_type: 'text',
            });
        }
    };

    return (
        <div className={`${styles.TheComp} Rapid-Series-E GtmModuleSection-section`} data-section-id={'Rapid-Series-E'}>
            <EcoSpace />
            <h2 className="title">{t('title')}</h2>
            <div className="swiperContainer">
                <Swiper
                    className="device-swiper"
                    modules={[Pagination, Navigation]}
                    spaceBetween={0}
                    loop
                    autoplay
                    initialSlide={0}
                    navigation={{
                        prevEl: '.device-swiper-navigation-left',
                        nextEl: '.device-swiper-navigation-right',
                    }}
                    slidesPerView={'auto'}
                    pagination={{
                        clickable: true,
                        el: '.swiper-pagination',
                        type: 'bullets',
                        renderBullet: (index, className) => {
                            return `<span class="${className}"></span>`;
                        },
                    }}
                    onSlideChange={handleSlideChange}
                    onSwiper={changeSwiper}
                >
                    {Img_List.map((item, idx) => (
                        <SwiperSlide className="swiper-item" key={idx} onMouseEnter={hanldleMouseEnter} onMouseLeave={hanldleMouseLeave}>
                            <EfImg pc={item.pc} h5={item.h5} />
                        </SwiperSlide>
                    ))}
                </Swiper>
                <div className="swiper-pagination"></div>
                {Img_List?.length > 1 && (
                    <>
                        <button
                            className="device-swiper-navigation GtmModuleData-btn-text device-swiper-navigation-left"
                            onClick={() => handleNavigationClick('prev')}
                        >
                            <Arrow />
                        </button>
                        <button
                            className="device-swiper-navigation GtmModuleData-btn-text device-swiper-navigation-right"
                            onClick={() => handleNavigationClick('next')}
                        >
                            <Arrow />
                        </button>
                    </>
                )}
            </div>
            <div className="tabContainer">
                <div className="tabContent" ref={tabContainerRef}>
                    {/* <EcoTab items={Tab_List} activeKey={String(activeIndex)} onChange={handleTabClick} /> */}
                    {Tab_List.map((item, idx) => (
                        <div
                            key={idx}
                            ref={targetRef}
                            className={`tabItem ${activeIndex === idx ? 'active' : ''} GtmModuleData-btn-text tab-${idx + 1}`}
                            onClick={() => handleTabClick(idx)}
                        >
                            {item.tabLabel}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default DeviceSwiper;
